import { Controller } from "@hotwired/stimulus"
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Tooltip } from "chart.js"

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip)

export default class extends Controller {
  static values = { data: Object }

  connect() {
    const labels = Object.keys(this.dataValue)
    const values = Object.values(this.dataValue)

    new Chart(this.element, {
      type: "bar",
      data: {
        labels: labels,
        datasets: [{
          label: "Revenue ($)",
          data: values,
          backgroundColor: "rgba(124, 58, 237, 0.6)",
          borderColor: "rgba(124, 58, 237, 1)",
          borderWidth: 1,
          borderRadius: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (context) => "$" + parseFloat(context.raw).toFixed(2)
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => "$" + value
            }
          }
        }
      }
    })
  }
}
